// extracted by mini-css-extract-plugin
module.exports = {"font":"cart_font__3q4Ke"};